var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramGreenLoan40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-11.000000, -99.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(11.000000, 99.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogramI/Greenloan",
    transform: "translate(7.000000, 10.000000)",
    stroke: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pictogram",
    transform: "translate(0.000000, 0.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tree",
    transform: "translate(0.000000, 0.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,6.49988483 C0.5,10.089817 3.41018304,13 7.00011517,13 C10.589817,13 13.5,10.089817 13.5,6.49988483 C13.5,2.91018304 10.589817,0 7.00011517,0 C3.41018304,0 0.5,2.91018304 0.5,6.49988483 Z",
    id: "Stroke-70",
    fill: "#00AA00"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 5,
    x2: 7,
    y2: 19,
    id: "Stroke-74"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.99988372,
    y1: 9.95238095,
    x2: 4.5,
    y2: 7.5,
    id: "Stroke-76"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,5.15129092 L23.5,10.1594742 L23.5,19 L11.5,19 L11.5,10.1594742 L17.5,5.15129092 Z",
    id: "Home",
    fill: "#FFFFFF"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramGreenLoan40);
export default __webpack_public_path__ + "static/media/pictogramGreenLoan40.10ffeace96b65b23033934a4b7b04eba.svg";
export { ForwardRef as ReactComponent };